/* src/app/components/layout/right-menu/right-menu.component.scss */
:host ::ng-deep .mat-mdc-progress-spinner circle,
.mat-mdc-progress-spinner circle {
  stroke: #ffd54f;
}
.icon::before {
  display: inline-block;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}
.current-user-button {
  min-width: 245px;
}
.logout-button {
  background-color: #F64040;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.logout-button:hover {
  background-color: #d53737 !important;
}
.case-name-dropdown {
  font: 14px Roboto, sans-serif;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8705882353);
}
:host-context(.dark-theme) .case-name-dropdown {
  color: white;
}
.customize-mat-menu {
  --padding: 0;
}
.lexbe-toolbar {
  overflow: hidden;
  white-space: nowrap;
  height: 55px;
  color: black;
  padding-top: 0;
}
.notification-button {
  border-right-width: 1px;
  border-right-color: #BDBDBD;
  border-right-style: solid;
  border-radius: 0;
}
.notification-button.mat-mdc-button {
  --mdc-text-button-container-height: 100%;
}
.notification-button .fa-circle {
  color: #FF0000;
}
:host-context(.dark-theme) .notification-button {
  border-right-color: rgb(88, 88, 88);
}
:host-context(.dark-theme) .hide-show-button {
  border-right-color: rgb(88, 88, 88);
}
:host-context(.dark-theme) .notification-button .fa-circle {
  color: #ff5b4f;
}
#current-case-icon {
  color: #223f92;
}
.hide-show-button {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  border-right: 1px solid #BDBDBD;
}
::ng-deep .cdk-overlay-pane .spinner {
  padding-right: 25px;
}
.notification-checkbox-container {
  font-size: 12px;
  text-align: center;
}
.no-processing-steps-active {
  font-size: 12px;
  text-align: center;
  cursor: default;
}
.notification-checkbox {
  accent-color: #223F92;
  height: 100%;
  vertical-align: middle;
}
/*# sourceMappingURL=right-menu.component.css.map */
